import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Bulletin' })((theme) => ({
    root: {
        display: 'flex',
        overflow: 'hidden',
        height: '100%',
        [theme.breakpoints.up(MOBILE_BREAK_POINT)]: {
            minWidth: 960
        }
    },
    spinner: {
        padding: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        boxSizing: 'border-box'
    }
}));
